//! @/script/checkout.js

function setHarsikaTotal(el) {
  var $el = $(el),
    code = $(el).data("type"),
    value = $(el).prop("checked") ? 1 : 0;

  $.post("index.php?route=extension/total/harsika/set", { code, value })
    .done((json) => $(".checkout__total").html(json["harsika_total"]))
    .fail(() => $el.prop("checked", !value));
}

function checkout(payment_method = "bank_transfer") {
  let $form = $("#checkout");

  if (!formValidate($form)) return;

  buttonLoad($("#checkout-button"));

  let jqXHR = $.get("index.php?route=checkout/guest");
  jqXHR.fail(function () {
    responseError();
  });
  jqXHR.done(function (response) {
    // Группа и страна пользователя
    let country_id = $(response).find("#input-payment-country").val();
    let customer_group_id = $(response).find("[name=customer_group_id]").val();

    // Группа пользователя
    let jqXHR_2 = $.get(
      "index.php?route=checkout/checkout/customfield&customer_group_id=" +
        customer_group_id
    );
    jqXHR_2.fail(function () {
      responseError();
    });
    jqXHR_2.done(function (response) {
      // Страна пользователя
      let jqXHR_3 = $.get(
        "index.php?route=checkout/checkout/country&country_id=" + country_id
      );
      jqXHR_3.fail(function () {
        responseError();
      });
      jqXHR_3.done(function (response) {
        let zone_id = "";

        $.each(response.zone, function () {
          if (this.name == "Moscow") {
            zone_id = this.zone_id;
            return false;
          }
        });

        // Форма
        let formParams = $form.serializeArray();
        formParams.push(
          {
            name: "country_id",
            value: country_id,
          },
          {
            name: "customer_group_id",
            value: customer_group_id,
          },
          {
            name: "zone_id",
            value: zone_id,
          }
        );

        // Данные формы
        let jqXHR_4 = $.post("index.php?route=checkout/guest/save", formParams);
        jqXHR_4.fail(function () {
          responseError();
        });
        jqXHR_4.done(function (response) {
          if (!responseCheck(response)) return;

          // Способ оплаты
          let jqXHR_5 = $.get("index.php?route=checkout/payment_method");
          jqXHR_5.fail(function () {
            responseError();
          });
          jqXHR_5.done(function (response) {
            var methods = [];

            $(response)
              .find("[name=payment_method]")
              .each(function () {
                methods.push($(this).val());
              });

            if (methods.indexOf(payment_method) === -1) {
              responseError();
              return;
            }

            // if (methods.indexOf("yoomoney") !== -1) {
            //   payment_method = "yoomoney";
            // } else if (methods.indexOf("tinkoff") !== -1) {
            //   payment_method = "tinkoff";
            // } else {
            //   payment_method = methods[0];
            // }

            let params = {
              agree: 1,
              payment_method,
              comment: $form.find("#input-comment").val(),
            };

            // return;

            let jqXHR_6 = $.post(
              "index.php?route=checkout/payment_method/save",
              params
            );
            jqXHR_6.fail(function () {
              responseError();
            });
            jqXHR_6.done(function (response) {
              if (!responseCheck(response)) return;

              $.get("/index.php?route=checkout/confirm")
                .fail(function () {
                  responseError();
                })
                .done(function (response) {
                  if (payment_method === "yoomoney") {
                    createPaymentYoomoney();
                    return;
                  }

                  if (payment_method === "tinkoff") {
                    createPaymentTinkoff(response);
                    return;
                  }

                  $.post(
                    `/index.php?route=extension/payment/${payment_method}/confirm`
                  )
                    .fail(function () {
                      responseError();
                    })
                    .done(function () {
                      document.location = "/index.php?route=checkout/success";
                      // window.location.href = "index.php?route=checkout/success";

                      // let jqXHR = $.post('index.php?route=checkout/success');
                      // jqXHR.done(function(response) {
                      // $('#modal .modal-body').html(response);
                      // });
                    });
                });
            });
          });
        });
      });
    });
  });
}

function createPaymentYoomoney() {
  $.ajax({
    url: "/index.php?route=extension/payment/yoomoney/create",
    dataType: "json",
    method: "GET",
    data: {
      paymentType: "",
      qiwiPhone: "",
      alphaLogin: "",
    },
    success: function (data) {
      if (data.success) {
        document.location = data.redirect;
      } else {
        responseError();
      }
    },
  });
}

function createPaymentTinkoff(html) {
  const $form = $(html).filter("#payment-existing-form");

  if ($form.length) {
    document.location = $form.attr("action");
  } else {
    responseError();
  }
}
